import Landings from './landings';

window.landings = new Landings();
